import { BaseEntity, type Searchable } from './base'

export const courtAuthorities = [
  'Tribunale ordinario',
  'Sezione distaccata di tribunale',
  "Corte d'Appello",
  "Sezione distaccata di corte d'appello",
  'Giudice di pace',
  'Cassazione',
]

export class Court extends BaseEntity implements Searchable {
  authority!: string
  site!: string
  officeCode!: string

  get searchString() {
    return this.authority + ' ' + this.site + ' ' + this.officeCode
  }

  get displayName() {
    return this.authority + ' - ' + this.site
  }
}

export class NewCourt {
  authority!: string
  site!: string
  officeCode?: string | null
}

export class UpdateCourt {
  authority?: string
  site?: string
  officeCode?: string | null
}

export interface GetAllCourts {
  courts: Court[]
}

interface BaseGetCourt {
  court: Court
}

export type CourtCreated = BaseGetCourt
export type CourtUpdated = BaseGetCourt
export type GetCourt = BaseGetCourt

export class MergeCourts {
  targetId!: string
  duplicateId!: string
}
